import { actions } from '../../utils/constants';

export const fetchAdmins = () => ({
    type: actions.ASYNC_FETCH_ADMINS,
});

export const createAdmin = (admin) => ({
    type: actions.ASYNC_CREATE_ADMIN,
    payload: { ...admin },
});

export const deleteAdmin = (adminId) => ({
    type: actions.ASYNC_DELETE_ADMIN,
    payload: { adminId },
});



// WEBPACK FOOTER //
// ./src/components/admins/admins.actions.js